import { useState } from 'react';
import TabbedCard from 'components/ui/TabbedCard';
import FormattedAddress from 'components/FormattedAddress/FormattedAddress';
import { EMDASH } from 'constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const AddressContactInfo = ({ application, careFacility, lightMode = false }) => {
  const history = useHistory();
  const [addressTab, setAddressTab] = useState('location');
  const [contactTab, setContactTab] = useState('location');

  return (
    <div className="flex flex-col md:flex-row gap-10 md:gap-8">
      <div className="flex-1">
        <h3 className={`text-[13px] leading-none tracking-1 mb-4 uppercase ${lightMode ? 'text-gray-500' : ''}`}>
          Address
        </h3>

        <TabbedCard
          color={lightMode ? 'default' : 'primary-dark'}
          activeKey={addressTab}
          onChange={setAddressTab}
          items={[
            {
              key: 'location',
              label: 'Location',
              children: (
                <div>
                  {application?.careFacility?.address ? (
                    <FormattedAddress address={application.careFacility.address} />
                  ) : (
                    'N/A'
                  )}
                </div>
              ),
            },
            {
              key: 'billing',
              label: 'Billing',
              children: (
                <div>
                  {application?.careFacility?.mailingAddress && !application?.careFacility?.mailingAddressSameAsOrg ? (
                    <FormattedAddress address={application.careFacility.mailingAddress} />
                  ) : (
                    <span className="italic">Same as location</span>
                  )}
                </div>
              ),
            },
          ]}
        />
      </div>

      <div className="flex-1">
        <h3 className={`text-[13px] leading-none tracking-1 mb-4 uppercase ${lightMode ? 'text-gray-500' : ''}`}>
          Contact Info
        </h3>

        <TabbedCard
          color={lightMode ? 'default' : 'primary-dark'}
          activeKey={contactTab}
          onChange={setContactTab}
          items={[
            {
              key: 'location',
              label: 'Location',
              children: (
                <div className="space-y-1">
                  {careFacility?.facilityContact ? (
                    <>
                      <div className="font-medium">{careFacility.facilityContact.displayName || EMDASH}</div>
                      <div>{careFacility.facilityContact.position || EMDASH}</div>
                      {careFacility.facilityContact.email && (
                        <a
                          href={`mailto:${careFacility.facilityContact.email}`}
                          className={`table border-b border-dashed pb-0.5 ${
                            lightMode
                              ? 'border-gray-400 !text-blue-600 hover:!text-blue-800 hover:!border-blue-800'
                              : 'border-gray-300 !text-gray-300 hover:!text-white hover:!border-white'
                          }`}
                        >
                          {careFacility.facilityContact.email}
                        </a>
                      )}
                      {careFacility.facilityContact.phone && <div>{careFacility.facilityContact.phone}</div>}
                    </>
                  ) : (
                    <div className="italic">Not provided</div>
                  )}
                </div>
              ),
            },
            {
              key: 'billing',
              label: 'Billing',
              children: (
                <div className="space-y-1">
                  {application?.careFacility?.organization?.billingContact ? (
                    <>
                      <div className="font-medium">
                        {application.careFacility.organization.billingContact.displayName || EMDASH}
                      </div>
                      <div>{application.careFacility.organization.billingContact.position || EMDASH}</div>
                      {application.careFacility.organization.billingContact.email && (
                        <a
                          href={`mailto:${application.careFacility.organization.billingContact.email}`}
                          className={`table border-b border-dashed pb-0.5 ${
                            lightMode
                              ? 'border-gray-400 !text-blue-600 hover:!text-blue-800 hover:!border-blue-800'
                              : 'border-gray-300 !text-gray-300 hover:!text-white hover:!border-white'
                          }`}
                        >
                          {application.careFacility.organization.billingContact.email}
                        </a>
                      )}
                      {application.careFacility.organization.billingContact.phone && (
                        <div>{application.careFacility.organization.billingContact.phone}</div>
                      )}
                    </>
                  ) : (
                    <div className="italic">Same as location</div>
                  )}
                </div>
              ),
            },
            {
              key: 'login',
              label: 'Login',
              children: (
                <div className="space-y-1">
                  <div className="font-semibold">{careFacility?.facilityContact?.displayName}</div>
                  {application?.createdBy?.email}
                  {application?.createdBy?.id && (
                    <a
                      href={`/admin/update-user/${application.createdBy.email}`}
                      onClick={(e) => {
                        e.preventDefault();
                        history.push(`/admin/update-user/${application.createdBy.email}`);
                      }}
                      className={`table border-b border-dashed !mt-4 pb-0.5 ${
                        lightMode
                          ? 'border-gray-400 !text-blue-600 hover:!text-blue-800 hover:!border-blue-800'
                          : 'border-gray-300 !text-gray-300 hover:!text-white hover:!border-white'
                      }`}
                    >
                      Manage in Users ↗
                    </a>
                  )}
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default AddressContactInfo;
